import ReferralsContainer from './ReferralsContainer';

export {
  ReferralsContainer
};

export default ReferralsContainer;
